import React, { useContext } from 'react'
import { useTypedTranslation } from 'app/modules/shared/hooks/use-translation'
import { getDownloadButtonStateAndMessage, humanFileSize, renderObjectToDataRows } from '../../helpers'
import { Collapse } from '../../components'
import { AuthButton } from 'app/modules/auth/components'
import { useReport } from '../../hooks'
import { reportContext } from '../../contexts'
import { ScanEngine } from '../../components/file-upload-modal/types'
import { applicationConfiguration, MainNotificationContext } from 'app/modules/shared'
import { reportsService } from '../../services'
import { downloadReportContent } from '../base-layout/report-controls/helpers'
import { HttpError } from 'app/modules/shared/exceptions'

export default function EmulationFileMetadata({
  name,
  ...data
}: {
  size: number
  line_count: number
  description: string
  name: string
}) {
  const config = useContext(applicationConfiguration)
  const { _t } = useTypedTranslation()
  const { flowId, reportId } = useReport()
  const reportsWrapper = useContext(reportContext)
  const scanEngine = reportsWrapper.getScanEngine(reportId) ?? ScanEngine.Internal
  const mainNotification = useContext(MainNotificationContext)

  const { disableButton, privateMessage } = getDownloadButtonStateAndMessage(
    flowId,
    reportId,
    scanEngine === ScanEngine.MDCloud ? false : true,
    false,
    config
  )

  const handleDownloadFile = async () => {
    try {
      if (reportId) {
        const [blobStr] = await reportsService.downloadPeEmulationFile(reportId, name)
        downloadReportContent(blobStr, name)
      }
    } catch (error) {
      let message = _t('report-download-error')

      if (error instanceof HttpError) {
        if (error.code === 404) {
          message = `${name} ${_t('file-not-found')}`.toLocaleLowerCase()
        } else if (error.code === 400) {
          message = error.message
        }
      }

      mainNotification.setMessageData(message, 'danger')
    }
  }

  const size = humanFileSize(data.size)
  const overview = renderObjectToDataRows({ ...data, size })
  const header = <div className="ellipsis">{name}</div>
  const body = (
    <>
      <div>{overview}</div>

      <div>
        <AuthButton
          className="gap-2"
          variant="primary"
          isPrivate={disableButton}
          privateMsg={_t(privateMessage)}
          disabled={disableButton}
          fileSize={data.size}
          sizeMsg={_t('empty-file')}
          onClick={handleDownloadFile}
        >
          <i className="ds3-icon ds3-download" />
          {_t('download')}
        </AuthButton>
      </div>
    </>
  )

  return <Collapse header={header} body={body} />
}
